// src/components/SignatureModal.js
import React, { useRef, useState, useEffect } from 'react';
import SignaturePad from 'react-signature-canvas';

const SignatureModal = ({ isOpen, onClose, onSave, reportId }) => {
  const sigCanvas = useRef({});
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  // Berechne die optimale Größe für die Signaturbox
  const canvasWidth = Math.min(windowDimensions.width * 0.8, 500);
  const canvasHeight = Math.min(canvasWidth * 0.6, 200);

  // Passe die Größe an, wenn das Fenster geändert wird
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Signatur löschen
  const clear = () => {
    sigCanvas.current.clear();
  };

  // Signatur speichern
  const save = () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Bitte unterschreiben Sie den Rapport');
      return;
    }

    // Signatur als Base64-kodiertes PNG erhalen
    const signatureData = sigCanvas.current.toDataURL('image/png');
    onSave(reportId, signatureData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <h2 className="text-xl font-semibold mb-4">Rapport unterschreiben</h2>
        <p className="mb-4">Bitte Unterschrift des Kunden hier erfassen:</p>
        
        <div className="border border-gray-300 mb-4 flex justify-center">
          <SignaturePad
            ref={sigCanvas}
            canvasProps={{
              width: canvasWidth,
              height: canvasHeight,
              className: "signature-canvas"
            }}
            backgroundColor="white"
          />
        </div>
        
        <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
          <button
            onClick={clear}
            className="bg-gray-200 text-gray-800 py-2 px-4 rounded hover:bg-gray-300"
          >
            Löschen
          </button>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
            >
              Abbrechen
            </button>
            <button
              onClick={save}
              className="bg-primary-600 text-white py-2 px-4 rounded hover:bg-primary-700"
            >
              Unterschrift speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;